export const PLAYOFF_STAGES = [
  {
    id: 18,
    stage: '1/8 финала',
    matches: [
      {
        id: '4001652',
        date: '2021-06-27T19:00:00.000Z',
        localTeam: {
          id: 6737,
          name: 'Бельгия',
          score: 1
        },
        visitorTeam: {
          id: 14227,
          name: 'Португалия',
          score: 0
        }
      },
      {
        id: '4000964',
        date: '2021-06-26T19:00:00.000Z',
        localTeam: {
          id: 11713,
          name: 'Италия',
          score: 2
        },
        visitorTeam: {
          id: 6295,
          name: 'Австрия',
          score: 1
        }
      },
      {
        id: '4001653',
        date: '2021-06-28T19:00:00.000Z',
        localTeam: {
          id: 9815,
          name: 'Франция',
          score: 3
        },
        visitorTeam: {
          id: 16598,
          name: 'Швейцария',
          score: 4
        }
      },
      {
        id: '4001650',
        date: '2021-06-28T16:00:00.000Z',
        localTeam: {
          id: 8243,
          name: 'Хорватия',
          score: 3
        },
        visitorTeam: {
          id: 15622,
          name: 'Испания',
          score: 5
        }
      },
      {
        id: '4001655',
        date: '2021-06-29T19:00:00.000Z',
        localTeam: {
          id: 16400,
          name: 'Швеция',
          score: 1
        },
        visitorTeam: {
          id: 17134,
          name: 'Украина',
          score: 2
        }
      },
      {
        id: '4001654',
        date: '2021-06-29T16:00:00.000Z',
        localTeam: {
          id: 8981,
          name: 'Англия',
          score: 2
        },
        visitorTeam: {
          id: 10245,
          name: 'Германия',
          score: 0
        }
      },
      {
        id: '4001651',
        date: '2021-06-27T16:00:00.000Z',
        localTeam: {
          id: 13169,
          name: 'Нидерланды',
          score: 0
        },
        visitorTeam: {
          id: 8460,
          name: 'Чехия',
          score: 2
        }
      },
      {
        id: '4000968',
        date: '2021-06-26T16:00:00.000Z',
        localTeam: {
          id: 17602,
          name: 'Уэльс',
          score: 0
        },
        visitorTeam: {
          id: 8671,
          name: 'Дания',
          score: 4
        }
      }
    ]
  },
  {
    id: 14,
    stage: '1/4 финала',
    matches: [
      {
        id: '4002999',
        date: '2021-07-02T19:00:00.000Z',
        localTeam: {
          id: 6737,
          name: 'Бельгия',
          score: 1
        },
        visitorTeam: {
          id: 11713,
          name: 'Италия',
          score: 2
        }
      },
      {
        id: '4003294',
        date: '2021-07-02T16:00:00.000Z',
        localTeam: {
          id: 16598,
          name: 'Швейцария',
          score: 1
        },
        visitorTeam: {
          id: 15622,
          name: 'Испания',
          score: 2
        }
      },
      {
        id: '4003583',
        date: '2021-07-03T19:00:00.000Z',
        localTeam: {
          id: 17134,
          name: 'Украина',
          score: 0
        },
        visitorTeam: {
          id: 8981,
          name: 'Англия',
          score: 4
        }
      },
      {
        id: '4002886',
        date: '2021-07-03T16:00:00.000Z',
        localTeam: {
          id: 8460,
          name: 'Чехия',
          score: 1
        },
        visitorTeam: {
          id: 8671,
          name: 'Дания',
          score: 2
        }
      }
    ]
  },
  {
    id: 12,
    stage: 'Полуфинал',
    matches: [
      {
        id: '4005016',
        date: '2021-07-06T19:00:00.000Z',
        localTeam: {
          id: 11713,
          name: 'Италия',
          score: 2
        },
        visitorTeam: {
          id: 15622,
          name: 'Испания',
          score: 1
        }
      },
      {
        id: '4005429',
        date: '2021-07-07T19:00:00.000Z',
        localTeam: {
          id: 8981,
          name: 'Англия',
          score: 2
        },
        visitorTeam: {
          id: 8671,
          name: 'Дания',
          score: 1
        }
      }
    ]
  },
  {
    id: 1,
    stage: 'Финал',
    matches: [
      {
        id: '4006729',
        date: '2021-07-11T19:00:00.000Z',
        localTeam: {
          id: 11713,
          name: 'Италия',
          score: 2
        },
        visitorTeam: {
          id: 8981,
          name: 'Англия',
          score: 1
        }
      }
    ]
  }
];
